import dayjs from "dayjs";

import { ProductType, type EventDetails, type ProductTypeEnum } from "@fitness-app/data-models/entities/Product";

import { type ProductFormModel } from "~/modules/Products/ProductForm/types";

const emptyToNull = (value?: string | null) => value?.trim() || null;

/** Maps the event fields of the product form onto the shape the backend validates; null for other types. */
export const getEventDetails = (type: ProductTypeEnum, form: ProductFormModel["eventDetails"]): EventDetails | null => {
  if (type !== ProductType.EVENT || !form?.dates?.[0]) {
    return null;
  }

  const [startsAt, endsAt] = form.dates;

  return {
    startsAt: startsAt.toISOString(),
    endsAt: endsAt ? endsAt.toISOString() : null,
    venueName: form.venueName.trim(),
    venueAddress: emptyToNull(form.venueAddress),
    city: emptyToNull(form.city),
  };
};

export const toEventDetailsFormValue = (details: EventDetails | null | undefined): ProductFormModel["eventDetails"] =>
  details
    ? {
        dates: [dayjs(details.startsAt), details.endsAt ? dayjs(details.endsAt) : null],
        venueName: details.venueName,
        venueAddress: details.venueAddress ?? null,
        city: details.city ?? null,
      }
    : null;
